import { render, staticRenderFns } from "./transformFee.vue?vue&type=template&id=6675bba6&scoped=true&"
import script from "./transformFee.vue?vue&type=script&lang=js&"
export * from "./transformFee.vue?vue&type=script&lang=js&"
import style0 from "./transformFee.vue?vue&type=style&index=0&id=6675bba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675bba6",
  null
  
)

export default component.exports